import { SET_FINANCIAL_CALCULATOR_DATA } from "./mutations";
import _ from "lodash";


const initialState = {
    offerPriceValue: 0,
    downPaymentPercentage: 0,
    acquisitionExpensesWorkingCapital: 0,
    interestRate: 1,
    monthlyPayments: 120,
    offerPrice: {},
    cashNeeded: {},
    earningsGeneratedBusiness: {},
    reasonableCompensation: {},
    reinvestmentAnalysis: {},
    investorReturn: {},
    debtService: {},
    financingTerms: {},
    financingResults: {},
    cashFlowMetrics: {},
    sellingPriceMultiples: {},
    debtServiceCoverageRatios:{},
    totalInterest: 0
  };

  const calculatorReducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case SET_FINANCIAL_CALCULATOR_DATA:
        return { ...state, ..._.cloneDeep(payload)}
  
      default:
        return state;
    }
  };
  
  export default calculatorReducer;

  